module.exports = __webpack_public_path__ + "static/br-be9fe7970407a6b317ca652c6f1a5329.svg";